const ROLES = {
  siteCreator: 'site_creator',
};

export default ROLES;
